import type { IconProps } from './types';

export const Maximize = ({ size, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.5 1.5H16.5M16.5 1.5V6.5M16.5 1.5L10.6667 7.33333M6.5 16.5H1.5M1.5 16.5V11.5M1.5 16.5L7.33333 10.6667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
